import React from "react";
import { Chip } from "@mui/material";

const FilterClip = ({
  label = "Filter",
  variant = "outlined",
  isSelected = false,
  icon,
  trailingIcon,
  onDelete,
  onClick,
  style,
  textStyle,
  ...props
}) => {
 
  return (
    <Chip
      label={label}
      variant={variant === "filled" ? "filled" : "outlined"}
      onClick={onClick}
      onDelete={onDelete || (() => {})} // ensures deleteIcon always shows
      deleteIcon={icon} // icon on the right
      style={{
        height: "32px",
        borderRadius: "16px",
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        ...(variant === "filled" && {
          backgroundColor: isSelected ? "#1976d2" : "#e0e0e0",
          color: isSelected ? "#ffffff" : "#000000",
        }),
        ...(variant === "primary" && {
          backgroundColor: isSelected ? "#1976d2" : "transparent",
          color: isSelected ? "#ffffff" : "#1976d2",
          borderColor: "#1976d2",
        }),
        ...(variant === "secondary" && {
          backgroundColor: isSelected ? "#9c27b0" : "transparent",
          color: isSelected ? "#ffffff" : "#9c27b0",
          borderColor: "#9c27b0",
        }),
        ...(variant === "warning" && {
          backgroundColor: isSelected ? "#ed6c02" : "transparent",
          color: isSelected ? "#ffffff" : "#ed6c02",
          borderColor: "#ed6c02",
        }),
     
        ...textStyle ,
   ...style,

      }}
      {...props}
    />
  );
};

export default FilterClip;
